import { lazy } from "react";
import { PAYMENTS } from "pages/routes/route.constant";
const payments = lazy(() => import("pages/Payments"));

export default {
  path: PAYMENTS,
  element: payments,
};
